import styled from 'styled-components';

export const UserPlanCardContainer = styled.div`
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  border: 1px solid #e0e0e0;
`;
